<template>
  <div class="settings-container">
    <h4 :style="themeFontColor">KCW</h4>
    <div class="p-grid setting-item-plus-chart p-mr-2">
      <div class="p-col" :style="themeFontColor">Line Width</div>
      <div class="p-col">
        <p-inputText type="number" v-model="kcwLineWidth" placeholder="20" />
      </div>
      <div class="p-col p-d-flex" style="gap: 0.5rem;">
        <color-picker v-model="kcwPeriodColor" :isSettingsPicker="true" />
      </div>
    </div>
  </div>
</template>
<script>
import ColorPicker from '@/baseComponents/ColorPicker.vue'
import { mapGetters } from "vuex";
import PlusChartSettingsComputed from "@/components/settingsHelper/PlusChartSettingsComputed"
export default {
  name: 'KCW_SettingsWindow',
  components: { ColorPicker },
  computed: {
    ...mapGetters(["themeFontColor"]),
    kcwLineWidth: {
      get: PlusChartSettingsComputed.kcwLineWidth.get,
      set(value) {
        this.$emit('runGeneralSetting', 'kcwLineWidth', value)
      }
    },
    kcwPeriodColor: {
      get: PlusChartSettingsComputed.kcwPeriodColor.get,
      set(value) {
        this.$emit('runGeneralSetting', 'kcwPeriodColor', value)
      }
    },
  }
}
</script>
<style scoped>





</style>